import border from './border';
import text from './text';
import background from './background';

export default {
  border,
  text,
  background,
};
